import(/* webpackMode: "eager", webpackExports: ["Transition"] */ "/vercel/path0/node_modules/@headlessui/react/dist/components/transition/transition.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/vercel/path0/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/BackerySchemaSnippet.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Breadcrumbs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/BreadcrumbsSnippet.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ClientCakeCalculator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/CookieBanner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/FAQSchemaSnippet.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/InstaFeed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/LazyLoadBackground.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/MasonryGallery.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/PostcodeDialog.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/PostcodeSearch.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ScrollToTop.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/VideoModal.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/WhatsAppButton.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/background-faqs.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/graphic-element-end@2x.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/trustpilot-logo-black.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/Vector-Dots.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/Vector-half-circle.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/Vector-half-circle2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/Vector-half-circle3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/Vector-quarter-circle2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/Vector-quarter-circle3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/Vector-radial-circles.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/Vector-radial-circles2.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/Faq/FaqCentered.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/Features/FeaturesHorizontal.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/Forms/CleanerJoinForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/Forms/ContactForm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/Hero/HeroOpener.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/Hero/PageOpener.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/Hero/PageOpenerWithSections.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/slices/PageWithSummary/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/StaticComponents/FlavoursMenu.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/slices/StaticComponents/TastingBox.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/slices/Testimonials/TestimonialsCarousel.js");
